import { render, staticRenderFns } from "./materialUpdate.vue?vue&type=template&id=74416a3e&scoped=true"
import script from "./materialUpdate.vue?vue&type=script&lang=js"
export * from "./materialUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74416a3e",
  null
  
)

export default component.exports